import { Currency } from 'services/stringFormating';

const defaultState = null;

export const currencyReducer = (state: Currency | null = defaultState) => state;
